import { companyPartialUpdaterBuilder } from "../companyPartialUpdaterBuilder";
import {
  CompanyOrgNumberFormik,
  COMPANY_ORG_NUMBER_FORM_MESSENGER_CONTEXT,
  validationCompanyOrgNumberSchema,
} from "./CompanyOrgNumberForm";

export const CompanyOrgNumberEdit = companyPartialUpdaterBuilder(CompanyOrgNumberFormik, {
  validationSchema: validationCompanyOrgNumberSchema,
  messengerContext: COMPANY_ORG_NUMBER_FORM_MESSENGER_CONTEXT,
});
